export const PAGO_STATUS = Object.freeze({
  SUCCESS: "success",
  PENDING: "pending",
  REJECTED: "rejected",
});
